import { CSSResult, html, TemplateResult, unsafeCSS } from 'lit';
import DERModuleElement from '~/modules/utils/der-module-element';

import { styles as globalStyles } from '~/ui/scss/main.styles';
import { styles } from './selected-data.styles';

export class SelectedData extends DERModuleElement {
    static override styles: CSSResult[] = [unsafeCSS(globalStyles), unsafeCSS(styles)];

    override render(): TemplateResult {
        return html` <div><slot></slot></div> `;
    }
}
